import styled from 'styled-components';
import _Container from 'products/nomad_insurance/components/Container';
import _NewWhatsIncluded from 'products/nomad_insurance/components/NewWhatsIncluded';
import Button from 'products/nomad_insurance/components/Button';
import { P } from 'components/Typography';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Container = styled(_Container)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${sizes.desktop} {
    flex-direction: row;
    align-items: flex-start;
    gap: 30px;
  }
`;

export const NewWhatsIncluded = styled(_NewWhatsIncluded)`
  padding: 24px 16px;
  border-radius: 24px;

  @media ${sizes.desktop} {
    padding: 32px;
  }
`;

export const InfoText = styled(P)`
  color: ${th('colors.pickledBluewood1')};
  letter-spacing: -0.16px;
`;

export const NextRow = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 12px;
  margin-top: 24px;

  @media ${sizes.tabletPortrait} {
    align-self: flex-end;
    align-items: flex-end;
  }
`;

export const NextButton = styled(Button)`
  padding: 9px 60px;
`;

export const Title = styled.h1`
  margin: 0;
  margin-bottom: 12px;
  font-size: 24px;
  line-height: 32px;

  @media ${sizes.desktop} {
    font-size: 32px;
    line-height: 40px;
  }
`;

export const SubTitle = styled.h2`
  margin: 24px 0 4px 0;
  font-size: 20px;
  line-height: 28px;
`;

export const MediumText = styled.b`
  font-weight: 500;
`;
